import { sendEmailCode } from '@/api/login'

const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const CODE_COUNTDOWN_SECONDS = 90

export default {
  data() {
    return {
      sendCodeLoading: false,
      emailCodeCountdown: 0,
      emailCodeTimer: null
    }
  },
  beforeDestroy() {
    this.clearEmailCodeTimer()
  },
  methods: {
    clearEmailCodeTimer() {
      if (this.emailCodeTimer) {
        clearInterval(this.emailCodeTimer)
        this.emailCodeTimer = null
      }
    },
    isValidRegisterEmail(email) {
      return EMAIL_REGEX.test(String(email || '').trim())
    },
    startEmailCodeCountdown() {
      this.clearEmailCodeTimer()
      this.emailCodeCountdown = CODE_COUNTDOWN_SECONDS
      this.emailCodeTimer = setInterval(() => {
        if (this.emailCodeCountdown <= 1) {
          this.emailCodeCountdown = 0
          this.clearEmailCodeTimer()
        } else {
          this.emailCodeCountdown -= 1
        }
      }, 1000)
    },
    handleSendEmailCode() {
      const email = this.registerForm.username.trim()
      if (!email) {
        this.$message.warning(this.$t('validation.emailRequired'))
        return
      }
      if (!this.isValidRegisterEmail(email)) {
        this.$message.warning(this.$t('validation.validEmailRequired'))
        return
      }
      if (this.emailCodeCountdown > 0 || this.sendCodeLoading) {
        return
      }
      this.sendCodeLoading = true
      sendEmailCode(email).then(res => {
        this.sendCodeLoading = false
        const msg = (res && res.message) || this.$t('tip.emailCodeSent')
        this.$message.success(msg)
        this.startEmailCodeCountdown()
      }).catch(() => {
        this.sendCodeLoading = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/registerEmailCode.js